import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.css';
import '../node_modules/wowjs/css/libs/animate.css'
import axios from 'axios'
import VideoPlayer from 'vue-video-player'
import 'animate.css';
import '../public/index.css'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

import { Tab, Tabs, Dialog, Icon, Toast} from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Toast);
import 'vant/lib/index.css';

Vue.use(VideoPlayer)
var echarts = require('echarts');
Vue.prototype.$echarts = echarts
// axios.defaults.baseURL = ''
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
      /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
      ak: 'C01tFQ5KslnI1icyGyB8pQFez8T8oPeI'
})
// axios.defaults.baseURL = 'https://hotel.sindon.cn/'

Vue.prototype.$http = axios
axios.defaults.timeout = 50000
// 添加请求拦截器
axios.interceptors.request.use((config)=>{
  // 添加header头的token
  // let token = "fabef0b85ed66b48ef5ba9a53134d4b776d353b753807a9fa3d28f1e608ed5eb"
  // let token = window.localStorage.getItem('token')
  // config.headers['SESSION-TOKEN'] = token
  // console.log(token)
  // if(token){
  //   config.headers.common['token'] =localStorage.getItem('token');
  // }
	// if(config.token === true){
	// 	config.headers['token'] = token
  // }
	// 显示loading
	// if(config.loading === true){
		// showLoading()
	// }
  // 在发送请求之前做些什么
	return config;
}, (error)=> {
	// 隐藏loading
	hideLoading()
  // 对请求错误做些什么
  // window.localStorage.removeItem('token')
  // window.localStorage.removeItem('userName')
  // window.localStorage.removeItem('userId')
	return Promise.reject(error);
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})




Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
